import React from 'react'
import Dialog, {DialogBody} from 'lib/ui/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import styled from 'styled-components'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import Button from 'lib/ui/Button'
import {Header} from 'lib/ui/typography'
import {Speaker} from 'Event/Speakers'
import {useAttendeeVariables} from 'Event'
import {useTownhallTemplate} from 'Event/template/Townhall'

export default function SpeakerModal(props: {
  speaker: Speaker
  showing: boolean
  onClose: () => void
}) {
  const {speaker, showing, onClose} = props
  const {textColor, speakers} = useTownhallTemplate()
  const nameColor = speaker.nameColor ?? speakers.nameColor ?? textColor

  return (
    <Dialog open={showing} maxWidth="lg">
      <DialogBody>
        <ModalContent
          speaker={speaker}
          color={textColor}
          nameColor={nameColor}
        />
      </DialogBody>
      <StyledDialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </StyledDialogActions>
    </Dialog>
  )
}

export function ModalContent(props: {
  speaker: Speaker
  color: string
  nameColor: string
}) {
  const {speaker, color, nameColor} = props
  const v = useAttendeeVariables()

  if (!speaker.image) {
    return (
      <ContentContainer color={color}>
        <StyledTitle color={nameColor}>{v(speaker.name)}</StyledTitle>
        <HTMLContent>{v(speaker.text)}</HTMLContent>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer color={color}>
      <StyledImage src={speaker.image} />
      <StyledTitle color={nameColor}>{v(speaker.name)}</StyledTitle>
      <StyledContent>{v(speaker.text)}</StyledContent>
    </ContentContainer>
  )
}

const ContentContainer = styled.div<{
  color: string
}>`
  color: ${(props) => props.color} !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${(props) => `${props.theme.spacing[4]} 0`};
`

const StyledImage = styled.img`
  border-radius: 50%;
  margin-bottom: ${(props) => props.theme.spacing[6]};
  object-fit: cover;
  width: 15rem;
  height: 15rem;
`

const StyledContent = styled(HTMLContent)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

const StyledTitle = styled(Header)<{color: string}>`
  margin-bottom: ${(props) => props.theme.spacing[6]};
  color: ${(props) => props.color};
`

const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: flex-end;
  padding: ${(props) => `${props.theme.spacing[6]}`};
`
